import { getAssetDomainByMPGlobals } from '../../../../lib/deployment'
import { IMeme } from './types'

export default [
  {
    punchline: 'How the rest of your bills wait for you after you pay the rent.',
    url: `https://images.cm.digitalturbine.com/static/nba_lockerroom_prank_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'That moment when you realize you’re an adult and have to visit the doctor alone.',
    url: `https://images.cm.digitalturbine.com/static/squidwardnotexr-1.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you’re about to sneak out of work…and your boss walks in.',
    url: `https://images.cm.digitalturbine.com/static/baby_sneaking_away_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How J. Lo feels in her 50s vs. how I feel in my 20s:',
    url: `https://images.cm.digitalturbine.com/static/ageless_jlo_vs_regular_me_8_2-2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your best friend asks you to save them a seat.',
    url: `https://images.cm.digitalturbine.com/static/doing_split_saving_seats_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'My alarms trying to wake me up in the morning.',
    url: `https://images.cm.digitalturbine.com/static/wake_up_snorlax_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Does anyone else remember these shin graters?',
    url: `https://images.cm.digitalturbine.com/static/metal_bike_pedal_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'What my face really looks like under my mask.',
    url: `https://images.cm.digitalturbine.com/static/under_my_mask.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your headphones get caught on a doorknob.',
    url: `https://images.cm.digitalturbine.com/static/handsome_squidward_headphones_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      'Do y’all ever get pre-annoyed? When you can see someone about to get on your nerves.',
    url: `https://images.cm.digitalturbine.com/static/fed_up_and_tired_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'That feeling when you nod off while watching TV too late at night',
    url: `https://images.cm.digitalturbine.com/static/blurry_elmo_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you’re about to sneak out of work…and your boss walks in.',
    url: `https://images.cm.digitalturbine.com/static/baby_sneaking_away_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'The doctor right after telling you the x-ray will be harmless.',
    url: `https://images.cm.digitalturbine.com/static/shaq_hiding.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your best friend asks you to save them a seat.',
    url: `https://images.cm.digitalturbine.com/static/doing_split_saving_seats_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'My alarms trying to wake me up in the morning.',
    url: `https://images.cm.digitalturbine.com/static/wake_up_snorlax_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Does anyone else remember these shin graters?',
    url: `https://images.cm.digitalturbine.com/static/metal_bike_pedal_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your headphones get caught on a doorknob.',
    url: `https://images.cm.digitalturbine.com/static/handsome_squidward_headphones_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      'Do y’all ever get pre-annoyed? Like, when you can see someone about to get on your nerves from across the room.',
    url: `https://images.cm.digitalturbine.com/static/fed_up_and_tired_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'That feeling when you nod off while watching TV too late at night.',
    url: `https://images.cm.digitalturbine.com/static/blurry_elmo_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How little kids think during their first time playing hide-and-seek.',
    url: `https://images.cm.digitalturbine.com/static/dog_on_dog_print_sheets_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'That feeling when the teacher uses your group project as a good example.',
    url: `https://images.cm.digitalturbine.com/static/aristocrats_in_frilly_shirts_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When a couple starts arguing and you're the third wheel.",
    url: `https://images.cm.digitalturbine.com/static/tom_hanks.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you get asked to complete a self-evaluation.',
    url: `https://images.cm.digitalturbine.com/static/teacher_asks_for_self_eval.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How an introvert feels after surviving an entire phone call',
    url: `https://images.cm.digitalturbine.com/static/jon_snow_almost_died_again.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How your pockets look at you after wasting money on stupid stuff.',
    url: `https://images.cm.digitalturbine.com/static/pants_looking_at_me_for_spending.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Me after almost running into someone on the highway.',
    url: `https://images.cm.digitalturbine.com/static/act_like_you_didnt_see.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: " I don't need a basket. I can carry everything.",
    url: `https://images.cm.digitalturbine.com/static/i_dont_need_a_basket.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "I'm on a light diet. I eat by daylight, moonlight and even refrigerator light.",
    url: `https://images.cm.digitalturbine.com/static/joey_eating_gross.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Grandparents be like one small snack before you go home.',
    url: `https://images.cm.digitalturbine.com/static/huge_chocolate_bar.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you're trying to act normal in front of unexpected company.",
    url: `https://images.cm.digitalturbine.com/static/normal_squidward.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When the cashier says, "These are 2 for 1. Did you want another one?"',
    url: `https://images.cm.digitalturbine.com/static/success_kid_crop.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'You and your siblings when your parents find something broken.',
    url: `https://images.cm.digitalturbine.com/static/spidey_vs_spidey_vs_spidey.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "How I look at a question when I didn't study.",
    url: `https://images.cm.digitalturbine.com/static/auntie_cant_see.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When the smell from the oven hits the living room',
    url: `https://images.cm.digitalturbine.com/static/spice_adams_rubs_hands.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When the seeze is coming out whether you like it or not.',
    url: `https://images.cm.digitalturbine.com/static/spongebob_irritated_face.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: '"Did I leave the stove on?" "Yeah, I definitely left the stove on"',
    url: `https://images.cm.digitalturbine.com/static/Sad_Keanu_Reeves.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you accomplish something at work that goes unnoticed.',
    url: `https://images.cm.digitalturbine.com/static/Obma_awarding_Obama.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When the line is long, but a new register opens up.',
    url: `https://images.cm.digitalturbine.com/static/excited_Sandy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "How I look telling myself I'm going to clean my room.",
    url: `https://images.cm.digitalturbine.com/static/pinnochio.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you've already seen the movie and the best part is coming up",
    url: `https://images.cm.digitalturbine.com/static/spongebob_knows_a_secret.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "How I laugh in public when I'm dressed nice.",
    url: `https://images.cm.digitalturbine.com/static/Monsieur_Candy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you speed up to switch lanes but end up behind a bus.',
    url: `https://images.cm.digitalturbine.com/static/kevin_hart_face.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "My face when it's hot out and someone is standing too close.",
    url: `https://images.cm.digitalturbine.com/static/mad_thomas_the_tank_engine.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When someone gets in trouble for doing what you were about to do.',
    url: `https://images.cm.digitalturbine.com/static/jim_halpert.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When the application says you need 10+ years of experience for an entry level job.',
    url: `https://images.cm.digitalturbine.com/static/when_the_job_application_says_you_need_10_years_of_experience.jpeg.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "That moment when you realize it's too late to start studying for tomorrow's exam.",
    url: `https://images.cm.digitalturbine.com/static/spongebob_red_eyes_studying_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How I take note of people that put pineapple on their pizza.',
    url: `https://images.cm.digitalturbine.com/static/Ryan_the_office_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How my bank account looks at the purchases I make.',
    url: `https://images.cm.digitalturbine.com/static/reggie_couz_reaction_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'That feeling after you lock your keys in the car...',
    url: `https://images.cm.digitalturbine.com/static/shrek_keys_in_the_car_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you call out sick, but see your boss in public.',
    url: `https://images.cm.digitalturbine.com/static/surprised_baby_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Hitting your funny bone on the corner of a table be like....',
    url: `https://images.cm.digitalturbine.com/static/squirwards_eye.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "How I hold. my phone when there's no service.",
    url: `https://images.cm.digitalturbine.com/static/holding_my_phone_no_service.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When the doctor asks if I've been drinking water, exercising and getting rest.",
    url: `https://images.cm.digitalturbine.com/static/caccoon_alien_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Dealing with your smelly little brother when your parents are gone.',
    url: `https://images.cm.digitalturbine.com/static/Ms_Puff_Spray_can_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'The way I play my music when no one else is home.',
    url: `https://images.cm.digitalturbine.com/static/spongebob_blasting_music_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Leaving work early on a Friday be like...',
    url: `https://images.cm.digitalturbine.com/static/mr_bean_riding_bike_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Waiting on the phone for customer service be like...',
    url: `https://images.cm.digitalturbine.com/static/bored_bart_simpson_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When someone criticizes your sneaker collection',
    url: `https://images.cm.digitalturbine.com/static/sneakerhead_meme_redo.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When pizza stands in the way of your good eating habits.',
    url: `https://images.cm.digitalturbine.com/static/workout_vs_pizza.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When someone shows up without letting me know they’re coming over.',
    url: `https://images.cm.digitalturbine.com/static/Bird_flying_into_face.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'I started a new exercise routine. Everyday I do diddly-squats.',
    url: `https://images.cm.digitalturbine.com/static/lazy_frog.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'My face when I’m eating a salad and someone brings in donuts.',
    url: `https://images.cm.digitalturbine.com/static/Shocked_Koala2.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Wait. This test had a backside?',
    url: `https://images.cm.digitalturbine.com/static/Shocked_Koala2.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When I find out you don’t wear sunscreen.',
    url: `https://images.cm.digitalturbine.com/static/Shocked_Koala2.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'My face when I’m trying to eat healthily and I see pizza.',
    url: `https://images.cm.digitalturbine.com/static/Shocked_Koala2.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How my kids walk by a sink full of dishes.',
    url: `https://images.cm.digitalturbine.com/static/blind_hamster.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'I really ought to do something… But I am already in my pajamas.',
    url: `https://images.cm.digitalturbine.com/static/Futurama_lab_coat.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Not sure if too much coffee or too little.',
    url: `https://images.cm.digitalturbine.com/static/Not_sure_if.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Not sure if ceiling fan is slowing down or staying the same speed.',
    url: `https://images.cm.digitalturbine.com/static/Not_sure_if.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Not sure if hungry or just bored.',
    url: `https://images.cm.digitalturbine.com/static/Not_sure_if.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Not sure if actually learning or just staring blankly at study notes.',
    url: `https://images.cm.digitalturbine.com/static/Not_sure_if.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Easy. Or I’m doing it wrong.',
    url: `https://images.cm.digitalturbine.com/static/Not_sure_if.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Not sure if serious or sarcastic.',
    url: `https://images.cm.digitalturbine.com/static/Not_sure_if.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How my kid smiles for a $200 package of school pictures.',
    url: `https://images.cm.digitalturbine.com/static/nervous_andy_bernard.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When I put the music on to clean the house then I forget to clean the house.',
    url: `https://images.cm.digitalturbine.com/static/squidward_filing_nails.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you hear your mom say your full name.',
    url: `https://images.cm.digitalturbine.com/static/Worried_surprised_kid.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'So Monday… we meet again.',
    url: `https://images.cm.digitalturbine.com/static/unaumsed_pug.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      'When the brightness is all the way up and you check your phone in the middle of the night.',
    url: `https://images.cm.digitalturbine.com/static/Patrick_burning.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'My face when men tell me to smile.',
    url: `https://images.cm.digitalturbine.com/static/Unimpressed_puppy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When the therapist says, “this sounds like a hard time for you.”',
    url: `https://images.cm.digitalturbine.com/static/Unimpressed_puppy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you really want to say something but you have to stop yourself.',
    url: `https://images.cm.digitalturbine.com/static/Unimpressed_puppy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'People trying to get sold out grocery supplies.',
    url: `https://images.cm.digitalturbine.com/static/fry_take_my_money.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you’re in the middle of writing a sentence and accidentally press send.',
    url: `https://images.cm.digitalturbine.com/static/Patrick_running.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Successfully quoting the whole movie.',
    url: `https://images.cm.digitalturbine.com/static/old_sport.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you left your phone to charge overnight but it wasn't plugged in. ",
    url: `https://images.cm.digitalturbine.com/static/patrick_crying.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "It's a case of mind over matter. I don't mind and you don't matter.",
    url: `https://images.cm.digitalturbine.com/static/grumpy_cat.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "There isn't any food, just a bunch of ingredients to make food. ",
    url: `https://images.cm.digitalturbine.com/static/first_world_probs_crop.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "I have 3 monitors attached to my computer and can't find the cursor. ",
    url: `https://images.cm.digitalturbine.com/static/first_world_probs_crop.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you definitely smelt it first, but hadn’t dealt it.',
    url: `https://images.cm.digitalturbine.com/static/mad_thomas_the_tank_engine.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Dogs when you tell them to stop barking at the mail man.',
    url: `https://images.cm.digitalturbine.com/static/holding_it_in.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Play it safe or run the yellow light?',
    url: `https://images.cm.digitalturbine.com/static/Fry_skeptical.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Watching your dog run into the same wall twice.',
    url: `https://images.cm.digitalturbine.com/static/face_palm_-_sir_patrick.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you have to spell your long name over the phone.',
    url: `https://images.cm.digitalturbine.com/static/face_palm_-_sir_patrick.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When I\'m shopping and get asked, "Do you work here?"',
    url: `https://images.cm.digitalturbine.com/static/kenan_steve_harvey.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'That feeling when you stub your toe on the bed frame.',
    url: `https://images.cm.digitalturbine.com/static/dawsons_creek.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "I don't always use my turn signal. But when I do, its always too late.",
    url: `https://images.cm.digitalturbine.com/static/most_interesting_man.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How old toys feel when kids grow up.',
    url: `https://images.cm.digitalturbine.com/static/redditors_wife.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you hear someone say your name in public.',
    url: `https://images.cm.digitalturbine.com/static/long_neck.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How the leader of a pyramid scheme shows off the product.',
    url: `https://images.cm.digitalturbine.com/static/Buzz_explains_to_Woody.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you hear your manager yelling from the next room.',
    url: `https://images.cm.digitalturbine.com/static/long_neck.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'My face when the driver that cut me off gets stuck behind a bus.',
    url: `https://images.cm.digitalturbine.com/static/Monsieur_Candy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your phone rings during class.',
    url: `https://images.cm.digitalturbine.com/static/incognitodrinking_from_straw.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'That feeling when your parents have to own up to their mistakes',
    url: `https://images.cm.digitalturbine.com/static/morpheus_what_if_i_told_you.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How you feel after losing a board game to a little kid.',
    url: `https://images.cm.digitalturbine.com/static/Sad_Keanu_Reeves.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you get a peek at the answer key before the test.',
    url: `https://images.cm.digitalturbine.com/static/spongebob_knows_a_secret.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When I think about how much time I'm going to spend on the couch this weekend.",
    url: `https://images.cm.digitalturbine.com/static/spice_adams_rubs_hands.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Politicians trying to win over voters',
    url: `https://images.cm.digitalturbine.com/static/pinnochio.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your mom tells you to be on your best behavior.',
    url: `https://images.cm.digitalturbine.com/static/normal_squidward.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How 6-year-old me used to look to ants',
    url: `https://images.cm.digitalturbine.com/static/savage_patrick.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When someone you didn't like in high school asks if you remember them.",
    url: `https://images.cm.digitalturbine.com/static/kenan_steve_harvey_fam_fued.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When the power goes out and you hear weird noises',
    url: `https://images.cm.digitalturbine.com/static/kevin_hart_look_at_this.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When your grandparents give you something your parents wouldn't let you have.",
    url: `https://images.cm.digitalturbine.com/static/creed_bratton_grandpa.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you get asked to speak to students at your old school.',
    url: `https://images.cm.digitalturbine.com/static/moira_rose_and_fans.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your boss gets mad at you, but you already got a better job offer.',
    url: `https://images.cm.digitalturbine.com/static/creed_bratton_sneaky_face.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When someone knocks on the door at a weird hour.',
    url: `https://images.cm.digitalturbine.com/static/kevin_hart_fornt_door.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'False! Pineapple does not go on pizza',
    url: `https://images.cm.digitalturbine.com/static/dwightschrute.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Fact! You are reading this meme in my voice.',
    url: `https://images.cm.digitalturbine.com/static/dwightschrute.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "Facts can't have alternatives. The alternative to a fact, is a falsehood.",
    url: `https://images.cm.digitalturbine.com/static/dwightschrute.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Holding in negative emotions be like...',
    url: `https://images.cm.digitalturbine.com/static/holding_it_in.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Losing the same level of a game over and over again.',
    url: `https://images.cm.digitalturbine.com/static/Vegeta_power_level.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "Me telling myself it's cool to spend a little rent money on video games.",
    url: `https://images.cm.digitalturbine.com/static/kermit_vs_kermit.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your social media post gets a tons of likes and shares',
    url: `https://images.cm.digitalturbine.com/static/moira_rose_and_fans.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you touch something wet that's supposed to be dry",
    url: `https://images.cm.digitalturbine.com/static/spongebob_irritated_face.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Looking at your cell phone bill the first month after switching.',
    url: `https://images.cm.digitalturbine.com/static/shocked_cat.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When the ball goes out of bounds during the 4th quarter.',
    url: `https://images.cm.digitalturbine.com/static/spidey_vs_spidey_vs_spidey.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Used car salesmen in movies be like...',
    url: `https://images.cm.digitalturbine.com/static/pinnochio.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "I don't always wear cologne. But when I do, you can smell it from a mile away.",
    url: `https://images.cm.digitalturbine.com/static/most_interesting_man.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'What if I told you, the gum you swallowed actually does get digested.',
    url: `https://images.cm.digitalturbine.com/static/morpheus_what_if_i_told_you.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "My face when I'm walking through the cut line at Six Flags.",
    url: `https://images.cm.digitalturbine.com/static/Monsieur_Candy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: " The milk you left out is the splinter in your mind that's driving you mad... ",
    url: `https://images.cm.digitalturbine.com/static/morpheus_what_if_i_told_you.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "People on the highway when there's an accident.",
    url: `https://images.cm.digitalturbine.com/static/long_neck.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When millennials hear teens refer to 90s music as "classics" or "oldies."',
    url: `https://images.cm.digitalturbine.com/static/lady_having_heart_attack.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'One does not simply press delete once on their calculator.',
    url: `https://images.cm.digitalturbine.com/static/one_does_not_simply.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you're grocery shopping and your wife calls every 5 minutes.",
    url: `https://images.cm.digitalturbine.com/static/guy_on_phone_snitching_-_store.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you're going 90 in a 55 and you drive past a state trooper.",
    url: `https://images.cm.digitalturbine.com/static/speeding_past_a_state_trooper.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Me 35 seconds after cancelling my plans.',
    url: `https://images.cm.digitalturbine.com/static/baby_watching_laptop.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'FYI, I carried all these groceries at once and only lost circulation in 4 fingers.',
    url: `https://images.cm.digitalturbine.com/static/spongebob_meh.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When I walk into a room and there are more people that I'd expected.",
    url: `https://images.cm.digitalturbine.com/static/embarrased_dog.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      'Me inspecting an item at the store because someone is standing in front of what I need.',
    url: `https://images.cm.digitalturbine.com/static/travolta_pulpfiction_grocery_store_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you cook dinner instead of ordering Uber Eats.',
    url: `https://images.cm.digitalturbine.com/static/house_on_the_prarie_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When the light has been green for 0.00159 seconds and someone blows their horn.',
    url: `https://images.cm.digitalturbine.com/static/angry_eyes_18_wheeler_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you\'re talking about your favorite celebrity and soemone says, "who?"',
    url: `https://images.cm.digitalturbine.com/static/angry_owl.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "Granddad coming out to check on all that hootin' and hollerin'.",
    url: `https://images.cm.digitalturbine.com/static/angry_owl.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Me when a large bill payment processes successfully.',
    url: `https://images.cm.digitalturbine.com/static/angry_kitten.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you walk into a room to take a test that you studied for.',
    url: `https://images.cm.digitalturbine.com/static/invincible.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "How I feel talking to a teacher I don't like on the last day before graduation.",
    url: `https://images.cm.digitalturbine.com/static/invincible.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you close the fridge and hear stuff fallling inside, but walk away anyway.',
    url: `https://images.cm.digitalturbine.com/static/jj_the_jet_plane_explosions.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you run away from your responsibilities.',
    url: `https://images.cm.digitalturbine.com/static/jj_the_jet_plane_explosions.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you have to explain to your parents why you were fighting at school.',
    url: `https://images.cm.digitalturbine.com/static/michael_jordan_took_it_personally_text.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When everyone told you not to panic buy, but you did anyway.',
    url: `https://images.cm.digitalturbine.com/static/this_is_fine_toilet_paper.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you're late to work but get there before your boss.",
    url: `https://images.cm.digitalturbine.com/static/Success_Kid.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Parents dropping off the baby before their first weekend alone.',
    url: `https://images.cm.digitalturbine.com/static/no_baby_this_weekend.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "Trying to fit into clothes you know you can't fit.",
    url: `https://images.cm.digitalturbine.com/static/lion_in_wheelbarrow.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you catch someone trying to be sneaky.',
    url: `https://images.cm.digitalturbine.com/static/superman_sees_flash.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "Holding in the urge to correct someone's grammar be like...",
    url: `https://images.cm.digitalturbine.com/static/spidey_holding_it_in.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you owe somebody money and they show up at the same event.',
    url: `https://images.cm.digitalturbine.com/static/jay_z_and_kanye_awkward.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you're second guessing your decision to cheat on your barber.",
    url: `https://images.cm.digitalturbine.com/static/simpsons_bad_cut.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "If you're waiting for service, does that make you the waiter?",
    url: `https://images.cm.digitalturbine.com/static/shocked_video_game.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your phone finally has enough battery for you to roll over in bed.',
    url: `https://images.cm.digitalturbine.com/static/cellphone_in_bed.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you show someone a picture in your phone and they start scrolling.',
    url: `https://images.cm.digitalturbine.com/static/hold_on_wait.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "Whe you're at the mall and see your salary on the price tag of a pair of shoes.",
    url: `https://images.cm.digitalturbine.com/static/will_smith_crying.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "How Windows responds when I'm looking for the file I just saved.",
    url: `https://images.cm.digitalturbine.com/static/windows_zach_efron_shrug.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Waking up after accidentally leaving the blinds open at night.',
    url: `https://images.cm.digitalturbine.com/static/pikachu_-_HELP.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When a dirty gas station has a clean bathroom.',
    url: `https://images.cm.digitalturbine.com/static/travolta_in_bathroom.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Your coach after you stray from the gameplan and let the other team score.',
    url: `https://images.cm.digitalturbine.com/static/omni_man_pathetic.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How I walk around corners after watching an action movie.',
    url: `https://images.cm.digitalturbine.com/static/Mr_bean_with_finger_gun.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When a little kid is telling you a long story and you forget a detail.',
    url: `https://images.cm.digitalturbine.com/static/omni_man_think.jpeg.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you've been trying to swat the same fly for hours.",
    url: `https://images.cm.digitalturbine.com/static/pikachu_boxing_glovers.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your ex sees you with your new partner.',
    url: `https://images.cm.digitalturbine.com/static/kristen_wiig_-_californians.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      'Me deciding where to place the slightly aggressive exclamation mark in a work email.',
    url: `https://images.cm.digitalturbine.com/static/Alan_counting_cards_-_hangover.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      "When the teacher asks for everyone's nickames, but keeps calling you by your first name.",
    url: `https://images.cm.digitalturbine.com/static/excuse_me.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you have to repeat a long order at the drive-thru window.',
    url: `https://images.cm.digitalturbine.com/static/oprah_frustrated.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you're trying to be serious and your friend won't stop cracking jokes.",
    url: `https://images.cm.digitalturbine.com/static/obama_and_joe.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Movie villains when they realize the good guy knows how to stop them.',
    url: `https://images.cm.digitalturbine.com/static/trump_-_what_you_say_.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you start playing UNO and have a handful of draw 4s.',
    url: `https://images.cm.digitalturbine.com/static/cap_with_shield_and_hammer.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Watching the news when you first get a 4K TV be like . . .',
    url: `https://images.cm.digitalturbine.com/static/nigel_thornberry_3d.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your social timer expires before the party is over.',
    url: `https://images.cm.digitalturbine.com/static/jay_z_is_not_here.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'That feeling when a big celebrity agrees with your tweet.',
    url: `https://images.cm.digitalturbine.com/static/beyonce_goddess.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you see your best friend walk into a boring event.',
    url: `https://images.cm.digitalturbine.com/static/jake_peralta_excited.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you get to work and see donuts.',
    url: `https://images.cm.digitalturbine.com/static/jake_peralta_excited.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'That moment right before someone you caught lying decides to spill the beans.',
    url: `https://images.cm.digitalturbine.com/static/Alan_counting_cards_-_hangover.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      'When someone leaves the bathroom without washing their hands and decides to touch you.',
    url: `https://images.cm.digitalturbine.com/static/obama_and_joe.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you wake up to the teacher asking you the answer to a math problem.',
    url: `https://images.cm.digitalturbine.com/static/kevin_hart_look_at_this.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When someone stops the entire game to read the rules.',
    url: `https://images.cm.digitalturbine.com/static/person-halfway-through-game-monopoly-and-someone-insists-on-reading-rulebook.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When I'm shopping for something specific and someone tries to sell me stuff.",
    url: `https://images.cm.digitalturbine.com/static/wack_face.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you open a pack of candy with kids around.',
    url: `https://images.cm.digitalturbine.com/static/group_of_corgis.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Stubbing your toe on the bedframe be like...',
    url: `https://images.cm.digitalturbine.com/static/seagull_yelling_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Me after someone tells me to watch my back.',
    url: `https://images.cm.digitalturbine.com/static/eyes_on_back_of_head.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Me after someone speeds around me and we end up at the same light.',
    url: `https://images.cm.digitalturbine.com/static/arm_out_the_window_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Your nosy neighbors when they hear loud music.',
    url: `https://images.cm.digitalturbine.com/static/dog_judges_people_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When babies hang out with their grandparents every day.',
    url: `https://images.cm.digitalturbine.com/static/grown_baby.jpeg.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How adventures lookd after ditching your imaginary friend for a cat.',
    url: `https://images.cm.digitalturbine.com/static/cat_instead_of_imaginary_friend.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your game save file gets deleted.',
    url: `https://images.cm.digitalturbine.com/static/crying_in_shower.jpeg.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'That one person in class that never has a pen.',
    url: `https://images.cm.digitalturbine.com/static/robot_face_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Freedom in America be like...',
    url: `https://images.cm.digitalturbine.com/static/united_states_spying.jpeg.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How you and your friends feel when you complete an escape room super fast.',
    url: `https://images.cm.digitalturbine.com/static/penguins_of_madagascar.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Sitting in rush hour traffic on a Friday be like...',
    url: `https://images.cm.digitalturbine.com/static/rush_hour_traffic.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      'My dad thinking of different ways he can come into my room, then leave the door open on his way out.',
    url: `https://images.cm.digitalturbine.com/static/Alan_counting_cards_-_hangover.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      "When the teacher tells the class to pick a partner and your best friend doesn't pick you. ",
    url: `https://images.cm.digitalturbine.com/static/Sad_Keanu_Reeves.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When you're wearinig socks and step in something wet. ",
    url: `https://images.cm.digitalturbine.com/static/spongebob_irritated_face.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "My wet phone trying to figure out what part of the screen I'm touching.",
    url: `https://images.cm.digitalturbine.com/static/Alan_counting_cards_-_hangover.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How I personally feel about my alarm clock every morning.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-_annoying_trumpet_boy_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Kids in the back of class when the teacher leaves for 5 minutes.',
    url: `https://images.cm.digitalturbine.com/static/borat_pulling_cart.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Trying to hide from my responsibilities like...',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-butthead_in_the_doghouse.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      'When the teacher lets us have water bottles in class, but mine is full of chocolate milk.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-Monsieur_Candy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Me after getting 100% on a test.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-Monsieur_Candy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When I already know the answer to the question my teacher is about to ask.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-Monsieur_Candy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'The perks of having an outlet close to your bed.',
    url: `https://images.cm.digitalturbine.com/static/cellphone_in_bed.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "10-year-old me learning that you don't catch the chicken pox from chickens.",
    url: `https://images.cm.digitalturbine.com/static/confused.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When someone called my house in 1995 and the Internet disconnected.',
    url: `https://images.cm.digitalturbine.com/static/dawsons_creek.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'We are "just friends."',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-dr_evil_air_quotes.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'False. Slow and steady does not win the race. Fast always wins.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-dwightschrute.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Toddlers trying to eat random objects.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-euro_cup_horse_collar_tackle.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How my dog feels when I get home from work.',
    url: `https://images.cm.digitalturbine.com/static/excited_Sandy.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "I've made easy mac 3,579 times but I still have to read the directions.",
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-facepalm_sir_patrick.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'I want to find ways to improve my memory, but I keep forgetting to look.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-facepalm_sir_patrick.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you tell your mom a joke and it turns into a lecture.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-facepalm_sir_patrick.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "I've seen 4 Fast and Furious movies, but can't remember which ones.",
    url: `https://images.cm.digitalturbine.com/static/first_world_probs_crop.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "The moment you realize you don't have any money left.",
    url: `https://images.cm.digitalturbine.com/static/first_world_probs_crop.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When the ice cream truck is passing my house.',
    url: `https://images.cm.digitalturbine.com/static/fry_take_my_money.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How I feel when life has been going smoothly for too long.',
    url: `https://images.cm.digitalturbine.com/static/Fry_skeptical.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Our houseguests when my dad makes a corny joke.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-goodfellas_laughing.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Oh, you said "exercise?" I thought you said "extra fries."',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-goodfellas_laughing.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "Me: What's up? Best Friend: The Sky",
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-goodfellas_laughing.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "Me unhappy with the fact that I'm awake at 4am.",
    url: `https://images.cm.digitalturbine.com/static/grumpy_cat.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Me when I have to share my toys with my younger sibling',
    url: `https://images.cm.digitalturbine.com/static/grumpy_cat.webp`,
    startDate: '07/14/21'
  },
  {
    punchline:
      'When the flip flops were made for comfort, but your mom throws them at you instead.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-mad_cricket_fan_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "Everyone's face when your hacker friend joins the game server.",
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-mad_cricket_fan_8_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'Me trying to hold my breath as long as a character in an action movie.',
    url: `https://images.cm.digitalturbine.com/static/holding_it_in.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When I have to walk past a group of cigarette smokers.',
    url: `https://images.cm.digitalturbine.com/static/holding_it_in.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When your class realizes you have gum.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-jack_sparrow_being_chased.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you and your friend say the same word at the exact same time.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-jake_peralta_excited.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When I say anything that resembles my dog's name.",
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-running_daschund_9_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: "When I'm shooping with my mom and she runs into a friend.",
    url: `https://images.cm.digitalturbine.com/static/jay_z_is_not_here.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'How your little sister sits until you agree to play a game with her.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-kangaroo_laying_9_2021.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When someone asks why I traded my little brother for a PS5.',
    url: `https://images.cm.digitalturbine.com/static/kermit_drinks_tea.webp`,
    startDate: '07/14/21'
  },
  {
    punchline: 'When you realize that waiting for a waiter makes you the waiter.',
    url: `https://images.cm.digitalturbine.com/static/Meme%20Templates%20-%208.31.2021-kermit_rainy_day_9_2021.webp`,
    startDate: '07/14/21'
  }
] as IMeme[]
